export default function registerAdept4ConnectionWizard(Alpine) {
  Alpine.data("adept4ConnectionWizard", ({ products_url, existing_id }) => ({
    productId: existing_id || "",
    products: [],
    nextCursor: null,
    loading: false,
    loadError: "",
    submitting: false,
    productsUrl: products_url,

    init() {
      this.loadProducts();
    },

    get canSubmit() {
      return !this.submitting && Boolean(this.productId);
    },

    async loadProducts() {
      this.loading = true;
      this.loadError = "";
      try {
        const url = this.nextCursor
          ? `${this.productsUrl}?cursor=${encodeURIComponent(this.nextCursor)}`
          : this.productsUrl;
        const resp = await fetch(url, { headers: { Accept: "application/json" } });
        if (!resp.ok) {
          const data = await resp.json().catch(() => ({}));
          this.loadError = data.error || `Failed to load products (${resp.status})`;
          return;
        }
        const data = await resp.json();
        this.products = this.products.concat(data.products || []);
        this.nextCursor = data.next_cursor || null;
      } catch (e) {
        this.loadError = e.message;
      } finally {
        this.loading = false;
      }
    }
  }));
}
